module.exports = __webpack_public_path__ + "img/lease-fee-icon.ee2df362.svg";